<template>
    <div class="main-page-body">
        <HighBoard
            @logOut="logOutClick"
            @clickCompany="openPageCompany"
            @clickDashboard="openPageDashboard"
            @clickModem="openPageModem(null)"
            @clickTable="openPageTable"
            :userData="userOptions"
            :choosenPage="choosenPage"
        />
    
        <Transition name="fade" mode="out-in">
            <component
                :is="activeComponent"
                :startModemId="startChoosedModemId"
                @goToModemPage="redirectToModem"
            />
        </Transition>
        <!-- <Transition name="fade" >
            <div class="agreement-notification-place" v-if="showAgreement">
                <div class="agreement-window">
                    <h2>Соглашение</h2>
                    <p style="width: 100%; display: flex; justify-content: space-between; max-width: 280px;">ФИО:
                        <el-input
                            v-model="FIOfield"
                            style="
                                width: 200px;
                                margin-top: 10px 0px;
                            "
                            size="small"
                            label="Элуктронная почта"
                            type="email"
                            placeholder="Введите ФИО"
                        />
                    </p>
                    <p style="width: 100%; display: flex; justify-content: space-between; max-width: 280px;">Эл. почта: 
                        <el-input
                            v-model="emailField"
                            style="
                                width: 200px;
                                margin-bottom: 10px 0px;
                            "
                            label="Элуктронная почта"
                            size="small"
                            type="email"
                            placeholder="Введите электронную почту"
                        />
                    </p>
                    
                    <div class="agreement-pdf-place">
                        <PDF src="agreement_v1.pdf" pdfWidth="100%" />
                    </div>
                    
                    <el-popover
                        trigger="hover"
                        placement="top"
                        :visible="statusFormDisable.status?null:false"
                        title=""
                        :width="250"
                        :content="statusFormDisable.text"
                    >
                        <template #reference>
                            <el-button type="primary" :disabled="statusFormDisable.status" @click="acceptAgreement">Я согласен</el-button>
                        </template>
                    </el-popover>
                </div>
            </div>
        </Transition> -->
    </div>
</template>
<script>
import axios from '../../config-axios'
import { shallowRef } from 'vue'
import PDF from "pdf-vue3";
import { mapMutations, mapGetters, mapActions } from 'vuex'
import { ElMessage } from 'element-plus'

import HighBoard from '@/components/Simple_elements/HighBoard.vue'
import DashboardVue from '@/pages/dashboard/DashboardPage.vue'
import CompanyVue from '@/pages/company/CompanyPage.vue'
import ModemPageVue from '@/pages/modem/ModemPage.vue'
import TablePage from '@/pages/table/TablePage.vue'

export default {
    name: 'MainWindow',
    computed: {
        ...mapGetters('user', {
            userOptions: 'getUserOptions',
        }),
    },
    data() {
        return {
            activeComponent: shallowRef(DashboardVue),
            startChoosedModemId: null,
            choosenPage: 'dashboard',
            flagEmailPopup: false,
            popupText: ''
        }
    },
    components: {
        HighBoard,
        DashboardVue,
        CompanyVue,
        ModemPageVue,
        TablePage,
        PDF
        // pdf
    },
    methods: {
        ...mapActions('user', {
            postLogout: 'postLogout',
        }),
        ...mapMutations('user', {
            mutationUser: 'setUserParam'
        }),
        logOutClick() {
            this.startChoosedModemId = null;
            this.choosenPage = 'dashboard';
            this.postLogout();
        },
        openPageCompany() {
            this.startChoosedModemId = null;
            this.choosenPage = 'company';
            this.activeComponent = shallowRef(CompanyVue);
            
        },
        openPageDashboard() {
            this.startChoosedModemId = null;
            this.choosenPage = 'dashboard';
            this.activeComponent = shallowRef(DashboardVue);
            
        },
        openPageModem(id) {
            if (id) {
                this.startChoosedModemId = id;
            } else {
                this.startChoosedModemId = null;
            }
            this.choosenPage = 'modem';
            this.activeComponent = shallowRef(ModemPageVue);
        },
        openPageTable() {
            this.startChoosedModemId = null;
            this.choosenPage = 'table';
            this.activeComponent = shallowRef(TablePage);
        },
        redirectToModem(id) {
            this.openPageModem(id);
        },
        validateEmail() {
        },
    },
    created() {
    },
    beforeUnmount() {
    }
}

</script>
<style noscoped lang="scss">
// .high-board{
//     width: 100vw;
//     background: #3F51B5;
//     height: 7vh;
//     box-shadow: 3px 13px 8px 0px rgba(34, 60, 80, 0.2);
//     display: flex;
//     align-items: center;
    
//     .logout{
//         cursor: pointer;
//         margin: 0px 1vw;
//         height: 50%;
//         background: #fff;
//         padding: 4px 10px;
//         border-radius: 4px;
//         i{
//             margin: 0px 6px;
//             color:#3f51b5;
//         }
//     }
// }
// .solo-company {
//     overflow: hidden;
//     transition: all .2s ease;
//     padding: 24px 30px;
//     display: grid;
//     grid-template-columns: repeat(3, 1fr);
//     gap: 10px;
// }
.main-page-body {
    position: relative;
}
.main-dask{
    height: 93vh;//issue: should be 93vh
    // display: flex;
    // align-items: flex-start;
    // justify-content: flex-start;
    // flex-direction: row;
    // flex-wrap: wrap;
    // align-content: flex-start;
    padding: 10px 1vw;
    overflow-y: auto;
}
@media screen and (max-width: 520px) {
    
}
</style>



